import React from 'react'
import { useNavigate } from 'react-router-dom'
import SubNavbar from './ui/SubNavbar'

export default function AdminSettingsNavbar({ selected, setState }) {
  const navigate = useNavigate()
  const state = new URLSearchParams(window.location.search).get("state")
  const activeState = state || selected || "general"

  const tabs = [
    { id: "general", label: "General Settings" },
    { id: "facilities", label: "Facilities & Booking" },
    { id: "contact", label: "Contact Information" },
    { id: "service", label: "Service Profile" },
  ]

  return (
    <div className="mb-4">
      <SubNavbar
        tabs={tabs}
        activeTab={activeState}
        onTabChange={(tabId) => {
          navigate(`/admin/settings?state=${tabId}`)
          if (setState) setState(tabId)
        }}
      />
    </div>
  )
}
